import styled from '@emotion/styled'
import { breakpoint, calcRem } from '../__styling'

const heroBackground = require('./assets/W.svg')

export const HeroBlockSection = styled('div')(() => ({
    padding: calcRem(32, 0, 0, 0),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    background: `url(${heroBackground}) right bottom / auto no-repeat, linear-gradient(303.51deg, #00074F 7.68%, #022195 53.64%, #043DE2 97.22%)`,

    [breakpoint('xs')]: {
        padding: calcRem(56, 0, 0, 0),
    },
}))

export const HeroContentSection = styled('div')(({ theme }) => ({
    padding: calcRem(0, 16),
    width: '100%',
    maxWidth: 1044,
    boxSizing: 'border-box',
    display: 'flex',
    position: 'relative',
    flexDirection: 'column',

    [breakpoint('xs')]: {
        padding: calcRem(0, 32),
        gap: calcRem(40),
        flexDirection: 'row',
    },
}))

export const StyledLeftContainer = styled('div')({
    margin: 'auto 0',
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    gap: calcRem(16),
    paddingBottom: calcRem(32),

    [breakpoint('xs')]: {
        flex: 3,
        gap: calcRem(24),
    },
})

export const StyledRightContainer = styled('div')({
    margin: '0',
    minWidth: 0,
    display: 'flex',
    flex: 1,

    [breakpoint('xs')]: {
        flex: 4,
    },
})

export const StyledHeroImage = styled('img')({
    marginLeft: 'auto',
    display: 'block',
    width: '100%',
    maxWidth: '100%',
    height: 'auto',
    alignSelf: 'end',
})

export const StyledTitleContainer = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    gap: calcRem(8),
})

export const StyledPageTitle = styled('h1')(({ theme }) => ({
    color: 'white',
    fontFamily: theme.fonts.sansSerif,
    fontWeight: 500,
    fontSize: calcRem(16),
    lineHeight: calcRem(24),

    margin: 0,
    padding: 0,
}))

export const StyledHeroTitle = styled('h2')(({ theme }) => ({
    color: 'white',
    fontFamily: theme.fonts.heading,
    fontWeight: 700,
    fontSize: calcRem(32),
    lineHeight: calcRem(40),

    margin: 0,
    padding: 0,
}))

export const StyledHeroSubText = styled('p')(({ theme }) => ({
    color: 'white',
    fontFamily: theme.fonts.sansSerif,
    fontWeight: 400,
    fontSize: calcRem(18),
    lineHeight: calcRem(28),

    margin: 0,
    padding: 0,
}))
